import "../../../callout.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.VisitStep ??= {};

AppointmentBooking.Wizard.Views.VisitStep.ProviderTypeCallout = class ProviderTypeCallout extends (
  AppointmentBooking.Wizard.Views.Callout
) {
  constructor() {
    super(...arguments);
    this.showProviderTypeDescription = this.showProviderTypeDescription.bind(this);
  }

  // EVENT HANDLERS

  handleProviderTypeDescriptionClick() {
    return this.showProviderTypeDescription();
  }

  showProviderTypeDescription() {
    this.$el
      .find('[data-appointment-booking-wizard-behaviour="show-provider-type-description"]')
      .toggleClass("caret-up");
    return this.$el.find(".provider-type-description").toggle();
  }
};
AppointmentBooking.Wizard.Views.VisitStep.ProviderTypeCallout.prototype.template =
  "step/visit/callouts/provider_type_message";

AppointmentBooking.Wizard.Views.VisitStep.ProviderTypeCallout.prototype.events = {
  'click [data-appointment-booking-wizard-behaviour="show-provider-type-description"]':
    "handleProviderTypeDescriptionClick",
};
